import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { analyticsChartTheme } from 'util/chartUtils';
import CardBox from 'components/kea/CardBox';
import DashboardStub from 'components/kea/DashboardStub';
import IntlMessages from 'util/IntlMessages';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

function Audience({ audience }) {
  const t = useLocalizedMessage();
  const options = {
    legend: {
      display: false,
      position: 'bottom',
    },
    textYIndex: 2,
  };

  const data = {
    labels: [
      t('recs.dashboard.audience.legend.lowQualityTraffic'),
      t('recs.dashboard.legend.didNotUseRecommendations'),
      t('recs.dashboard.legend.usedRecommendations'),
    ],
    datasets: [{
      data: [
        audience.bad,
        audience.noRecs,
        audience.recs,
      ],
      backgroundColor: [
        analyticsChartTheme.grid,
        analyticsChartTheme.clickRateFill,
        analyticsChartTheme.brand,
      ],
      hoverBackgroundColor: [
        analyticsChartTheme.border,
        analyticsChartTheme.clickRate,
        analyticsChartTheme.primaryDark,
      ],
    }],
    text: `${audience.recsPercentage}%`,
  };

  return (
    <CardBox header={t('recs.dashboard.audience.title')} styleName="recs-dashboard-card">
      {
        (audience.error) ? (<DashboardStub />)
          : (
            <div>
              <div className="row">
                <div className="col-12">
                  <p>{t('recs.dashboard.audience.interestedVisitorsUsedRecommendations', { rate: audience.recsPercentage })}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <Doughnut
                    height={200}
                    data={data}
                    options={options}
                  />
                </div>
                <div className="col-sm-6">
                  <table className="chartTable">
                    <tbody>
                      <tr>
                        <td>
                          <p><IntlMessages id="ui.recs.dashboard.audience.totalNumberOfUniqueVisitors" /></p>
                        </td>
                        <td>
                          <p className="textRight">{audience.total}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>
                            <IntlMessages id="ui.recs.dashboard.audience.gotInterestedInTheStore" />
                            <sup>*</sup>
                            <br />
                            <sup>*</sup>
                            <IntlMessages id="ui.recs.dashboard.audience.viewedAtLeast2Products" />
                          </p>
                        </td>
                        <td>
                          <p className="textRight">{audience.interested}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p><IntlMessages id="ui.recs.dashboard.audience.numberOfInterestedVisitorsWhoUsedRecommendations" /></p>
                        </td>
                        <td>
                          <p className="textRight">{audience.recs}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )
    }
    </CardBox>

  );
}

Audience.propTypes = {
  audience: PropTypes.shape({
    recsPercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    bad: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    noRecs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    recs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    interested: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.any,
  }).isRequired,
};

export default Audience;
